<script>
  export let rank;
  export let rankImage;
  export let rankText;
  export let rankColor;
  export let survey;
  export let answerMap;

  import ProgressBar from "../components/ProgressBar.svelte";
  import Warning from "../components/Warning.svelte";

  import { onMount } from "svelte";

  import * as animateScroll from "svelte-scrollto";

  onMount(() => {
    animateScroll.scrollTo({ element: "#result", duration: 500 });
  });
</script>

<style>
  div.result {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  div.result img {
    height: 350px;
    max-width: 90%;
  }

  div.rankText {
    padding: 20px;
    border-radius: 10px;
    color: white;
    -webkit-box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    -moz-box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    margin-top: 20px;
    max-width: 600px;
    text-align: center;
  }

  div.progressbar {
    width: 40%;
    margin-bottom: 70px;
    margin-top: 50px;
  }

  div.advices {
    margin-top: 20px;
  }

  /* Mobile phones */

  @media only screen and (max-width: 768px) {
    div.progressbar {
      width: 75%;
    }
  }
</style>

<div class="result" id="result">
  <div id="container" class="progressbar">
    <ProgressBar rankingValue={rank / 100} />
  </div>
  <img src={rankImage} alt="Rank" />
  <div class="advices">
    {#each survey as question, index}
      <Warning {question} {answerMap} numQuestion={index} />
    {/each}
  </div>
  <div class="rankText" style="background-color: {rankColor}">{rankText}</div>
</div>
